 
 
 
 
 
 
/**
 * Service for store and retrieve an specific unit measurement.
 *
 * This service is used by map instances, widgets and services to store their unit measurement configuration.
 *
 * If its constructor receive a UnitService instance as argument it will start listen changes in the
 * given instance and apply the same change in its own. That behavior allows the instances of this class to
 * be updated in cascade.
 *
 * @class UnitService
 * @module Services
 * @extends L.Evented
 * @constructor
 * @param {UnitService} [parent] If is defined makes the new instance a "slave" of the given instance
 */
define(['./unit', 'leaflet', './unitTypes', 'services/utils'], function(Unit, L, unitTypes, Utils) {
    'use strict';
    var UnitService, supportedUnits;

    var EVENTS = {
        /**
         * Fired after the unit is set.
         *
         * @event UNIT_CHANGED
         * @type String
         *
         * @example
         * ```javascript
         * var unitService = new UnitService();
         * unitService.on(L.UnitService.Events.UNIT_CHANGED, function(eventData) {
         *  console.log(eventData);  
         * });
         * ```
         */
        'UNIT_CHANGED': 'config.unit.changed'
    };

    function createUnitsArray() {
        return Object.keys(unitTypes).map(function(key) {
            return new Unit(key);
        });
    }

    supportedUnits = createUnitsArray();

    UnitService = L.Evented.extend({

        Events: EVENTS,

        initialize: function(parent) {
            if (parent instanceof UnitService) {
                this.currentUnit = new Unit(parent.getCurrentUnit().getLabel());
                this.parent = parent;
                parent.on(EVENTS.UNIT_CHANGED, function(unit) {
                    this.setCurrentUnit(unit.getLabel());
                }, this);
            } else {
                this.currentUnit = new Unit('metric');
            }
        },
        /**
         * Sets a new measurement unit.
         *
         * Fires the event {{#crossLink "UnitService/UNIT_CHANGED:event"}}{{/crossLink}}.
         *
         * @method setCurrentUnit
         * @param {String|Unit} [unit="metric"] accepts a string (`metric`, `imperial`) or a Unit instance
         */
        setCurrentUnit: function(unit) {
            if (!(unit instanceof Unit)) {
                unit = new Unit(unit);
            }
            this.currentUnit = unit;
            this.fire(EVENTS.UNIT_CHANGED, this.currentUnit);
        },

        /**
         * Gets currently setted unit.
         *
         * @method getCurrentUnit
         * @return {Unit}
         */
        getCurrentUnit: function() {
            return this.currentUnit;
        }
    });

    /**
     * Static method that returns an array with the supported units.
     * @static
     * @method UnitService.getSupportedUnits
     * @return {Unit[]}
     */
    UnitService.getSupportedUnits = function() {
        return supportedUnits;
    };

    L.unitService = function(parent) {
        return new UnitService(parent);
    };

    L.UnitService = UnitService;

    UnitService.Events = EVENTS;
    Utils.addDeprecatedProperty(UnitService.prototype, 'EVENTS', 'Events');

    return L.unitService;
});



// WEBPACK FOOTER //
// ./config/unit/unitService.js